module.exports = __webpack_public_path__ + "static/media/arrow_point_down.564c7014.svg";